export default __webpack_public_path__ + "static/media/ArrowIcon.c4b884a3.svg";